/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />

namespace TabAurous.Purchase {

    import fld = RateFixingItemsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class RateFixingItemsEditor extends _Ext.ItemGridEditor<RateFixingItemsRow> {


        protected getColumnsKey() { return "Purchase.RateFixingItems"; }
        protected getDialogType() { return RateFixingItemsDialog; }
        protected getLocalTextPrefix() { return RateFixingItemsRow.localTextPrefix; }
        protected form: RateFixingItemsForm;

        private pendingChanges: Q.Dictionary<any> = {};

        // #region Variables
        public PartyId: number;
        public BaseItemTypeId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public LaborMarkup: number;
        public ExchangeRate: number;
        public DeptId: number;
        private NewLineNo: number;
        private GenSKU = true;
        private contractTotals: string;
        public TotalItems: number;
        statement: string;

        // #endregion


        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ forceFitColumns: true });

            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as RateFixingDialog).CalculateAmountandTax(this.view.getItems(), this.view.getItems().length);
                }
            })
        } 
        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();

            var num = ctx => ColumnFormatter.numericInputFormatter(ctx, this);
            var int = ctx => ColumnFormatter.integerInputFormatter(ctx, this);
            var str = ctx => ColumnFormatter.stringInputFormatter(ctx, this);

            var Department = Q.first(columns, x => x.field === fld.DepartmentId);
            Department.referencedFields = [fld.DepartmentId];
            Department.format = ctx => ColumnFormatter.selectFormatter(ctx, fld.DepartmentId, OMS.DepartmentMasterRow.getLookup(), this);

            if (this.GenSKU == false) {
                Q.first(columns, x => x.field === fld.Pieces).format = int;
            }
            Q.first(columns, x => x.field === fld.Discount).format = num;
            Q.first(columns, x => x.field === fld.WstPer).format = num;


            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            return columns;
        }

        // #endregion
         
        //#region  ItemGrid Inline Editor
        // **** Delete event handler ****
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);


            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    Q.confirm('This will effect Stock and can not be undone, Are you sure want to delete? ', () => {
/*                        if (item.TransItemId > 0) {

                            // **** Validate StockId from Stock Transactions ****
                            let StockID;
                            Stock.StockItemService.GetStockTransactions({
                                LineNo: item.Line_No,
                                TransId: item.TransId,
                                Product_Id: item.ProductId,
                                Take: 1
                            },
                                response => StockID = response.Entities.length,
                                {
                                    async: false
                                });

                            Q.alert
                            if (StockID > 0 || StockID != null) {
                                Q.alert("This Item is used in other transactions, Can Not Delete!!");
                                return;
                            }
                            else {
                                Purchase.RateFixingItemsService.Delete({ EntityId: item.TransItemId });
                                Stock.StockItemService.Delete({ EntityId: StockID });
                                var id = this.id(item);
                                this.TotalItems = this.view.getItems().length - 1;
                                this.view.deleteItem(id);
                            }*
                        }
                        else {*/
                            var id = this.id(item);
                            this.TotalItems = this.view.getItems().length - 1;
                            this.view.deleteItem(id);
                        //}

                    });
                    this.view.refresh();
                    (this.parentDialog as RateFixingDialog).CalculateAmountandTax(this.view.getItems(), this.view.getItems().length);

                }

                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
        }

        
        //#region Inline Editor
        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject, ) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;

            // *** Validate Decimal & Integer***
            if (field === fld.Pieces || field === fld.Discount) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else if (input.hasClass('numeric')) {
                var i = Q.parseInteger(text);
                if (isNaN(i) || i > 32767 || i < 0) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else {
                value = text;
            }

            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Pieces && value > 0) {

                if (item.CalcOnId == 3) {
                    item.GrossAmount = item.UnitRate * value;
                    item.Weight = item.Pieces < value ? item.Weight * value : (item.Weight / item.Pieces) * value;
                    item.DiamondPieces = item.Pieces < value ? item.DiamondPieces * value : (item.DiamondPieces / item.Pieces) * value;
                    item.DiamondWeight = item.Pieces < value ? item.DiamondWeight * value : (item.DiamondWeight / item.Pieces) * value;
                    item.DiamondAmount = item.Pieces < value ? item.DiamondAmount * value : (item.DiamondAmount / item.Pieces) * value;
                    item.StonePieces = item.Pieces < value ? item.StonePieces * value : (item.StonePieces / item.Pieces) * value;
                    item.StoneWeight = item.Pieces < value ? item.StoneWeight * value : (item.StoneWeight / item.Pieces) * value;
                    item.StoneAmount = item.Pieces < value ? item.StoneAmount * value : (item.StoneAmount / item.Pieces) * value;
                    item.OtherPieces = item.Pieces < value ? item.OtherPieces * value : (item.OtherPieces / item.Pieces) * value;
                    item.OtherWeight = item.Pieces < value ? item.OtherWeight * value : (item.OtherWeight / item.Pieces) * value;
                    item.OtherAmount = item.Pieces < value ? item.OtherAmount * value : (item.OtherAmount / item.Pieces) * value;
                    item.NetWeight = item.Pieces < value ? item.NetWeight * value : (item.NetWeight / item.Pieces) * value;
                    if (item.WstPer != null) {
                        item.WstWt = item.NetWeight * (item.WstPer / 100);
                    }
                    item[field] = value;

                    this.view.updateItem(id, item);
                    this.view.refresh();
                }

            }
            // *** Calculate Wastage ***
            if (field === fld.WstPer && value >= 0) {
                item.WstWt = item.NetWeight * (value / 100);
                item[field] = value;
            }

            // *** Calculate Discount ***
            if (field === fld.Discount && value >= 0) {
                item.GrossAmount = item.NetAmount - value;
                item[field] = value;

            }

            // *** Set Department ***
            if (field === fld.DepartmentId && value > 0) {
                item[field] = value;

            }

            this.view.updateItem(id, item);
            this.view.refresh();
            (this.parentDialog as RateFixingDialog).CalculateAmountandTax(this.view.getItems(), this.view.getItems().length);

            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }

        // #endregion


        //// #region Buttons Add-Remove
        //protected getButtons() {
        //    let buttons = super.getButtons();
        //    buttons = buttons.filter(x => x.cssClass != "add-button");
        //    var grid = UnfixPurchaseSelectGrid;

        //    // *** Add Select Button to Grid Editor ***
        //    buttons.push({
        //        title: "Select Products",
        //        cssClass: "add-button",
        //        hotkey: "Alt+K",
        //        onClick: () => {

        //            // **** Validate Party before Item Selection ****
        //            if (isNaN(this.PartyId)) {
        //                Q.notifyWarning("Please select Supplier to proceed");
        //                return;

        //            }
        //            if (this.BaseItemTypeId == 0 || this.BaseItemTypeId== null) {
        //                Q.notifyWarning("Please select Item Type to proceed");
        //                return;

        //            }

        //            else {
        //                UnfixPurchaseSelectGrid.ledgerId = parseInt(this.PartyId.toString());
        //                UnfixPurchaseSelectGrid.BaseItemTypeId = parseInt(this.BaseItemTypeId.toString());
        //                var pickerDialog = new _Ext.GridItemPickerDialog({
        //                    gridType: grid, multiple: true, title: "Select Items",
        //                    preSelectedKeys: this.value.map(k => k.ProductId)
        //                });
        //            }

        //            pickerDialog.onSuccess = (selectedItems: any[]) => {
        //                let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
        //                //alert('Length' + selectedItems.length);
        //                var self = this;
        //                var orddetails = [];
        //                var purchaseLabor = [];
        //                var genSKU = this.GenSKU;
        //                var rateListId = this.RateListId;
        //                var laborListId = this.LaborListId;
        //                var laborMarkup = this.LaborMarkup;
        //                var rateMarkup = this.StoneMarkup;
        //                var newLineNo = this.NewLineNo;
        //                var deptId = this.DeptId;
        //                var companyId = Q.Authorization.userDefinition.CompanyId;
        //                var Rate = 0;
        //                var LaborRate = 0;
        //                var Pieces = 0;
                        
        //                var userDetails = Q.Authorization.userDefinition;


        //                // #region Items to Grid
        //                //for (let value of selectedItems2)
        //                selectedItems2.forEach(function (value) {
        //                    var PrdId = value.ProductId;
        //                    var AtbId = value.AttributeId;
        //                    var bomdetails = [];
        //                    var labordetail = [];
        //                    var PrdDetails = OMS.ProductMasterRow.getLookup().itemById[PrdId];
        //                    Purchase.PurchaseMasterService.GetLineNo({}, response => newLineNo = response.LineNo, {
        //                        async: false
        //                    });

        //                    // #region Product Attributes
        //                    // **** Load & assign Attributes of Product using AtbID ****
        //                    let ATBDetails = OMS.CommonAttributesRow.getLookup().itemById[AtbId]
        //                    var BaseItm = ATBDetails.ProductTypeId;
        //                    var ItemTypeId = ATBDetails.ItemTypeId;
        //                    var Type = ATBDetails.CategoryName;
        //                    var CategoryId = ATBDetails.CategoryId;
        //                    var SubType = ATBDetails.SubCategoryName;
        //                    var SubCategoryId = ATBDetails.SubCategoryId;
        //                    var Brand = ATBDetails.BrandName;
        //                    var BrandId = ATBDetails.BrandId;
        //                    var SuperType = ATBDetails.SuperTypeName;
        //                    var SuperTypeId = ATBDetails.SuperTypeId;
        //                    var Collection = ATBDetails.CollectionName;
        //                    var CollectionId = ATBDetails.CollectionId;
        //                    var CalcOn = PrdDetails.CalcOnId;
        //                    var Weight = value.Weight == undefined ? 1 : value.Weight;
        //                    var VoucherDetails = OMS.VoucherMasterRow.getLookup().items.filter(x => x.VoucherTypeId ==  )[0];
        //                    switch (ItemTypeId) {
        //                        case 101:
        //                            deptId = VoucherDetails.DefaultJewelleryDepartment;
        //                            break;
        //                        case 104:
        //                            deptId = VoucherDetails.DefaultMetalDepartment;
        //                            break;
        //                        case 105:
        //                            deptId = VoucherDetails.DefaultStoneDepartment;
        //                            break;
        //                    }
                            


        //                    // #endregion

        //                    // #region Rate, Tax , SKU & Labor 
        //                    var Rate = 0;
        //                    var LaborRate = 0;

        //                    // **** Get SKU for Item ****
        //                    if (genSKU == true) {
        //                        var SKU = FormatHelper.GetFormat("Sku", "HO");
        //                    }
                        
        //                    // #endregion
        //                    var purity = 0;
        //                    var pureweight = 0;
        //                    if (!value.HasBom) {
        //                        Q.reloadLookup(OMS.MetalRateMasterRow.lookupKey)
        //                        var MRate = OMS.MetalRateMasterRow.getLookup().items.filter(x => x.MetalTypeId == PrdDetails.MetalId && x.RateTypeId == 33
        //                            && x.CompanyId == userDetails.CompanyId && Q.formatDate(x.FromDate, "dd/MM/yyyy") <= Q.formatDate(self.Master.TransDate, "dd/MM/yyyy"));
        //                        Rate = MRate.pop().Rate;
        //                        if (value.Purity == 0)
        //                            value.Purity = OMS.AttributeMasterRow.getLookup().items.filter(x => x.AttributeId == ATBDetails.KaratId)[0].StdPurity;
        //                        purity = OMS.AttributeMasterRow.getLookup().items.filter(x => x.AttributeId == ATBDetails.KaratId)[0].StdPurity;
        //                    }

        //                    if (!value.HasBom) {
        //                        purity = value.Purity;
        //                        pureweight = value.Weight * purity;
        //                    }

        //                    //Calculate Tax Amount
        //                    //var TAmount = ((Rate + LaborRate) * ItemTax[1]) / 100;

        //                    var purchase: RateFixingItemsRow = {
        //                        ProductId: PrdId,
        //                        AttributeId: AtbId,
        //                        Line_No: newLineNo,
        //                        PartyId: self.PartyId,
        //                        SKU: SKU,
        //                        DepartmentId: deptId,
        //                        ProductCode: value.ProductCode,
        //                        ProductName: value.ProductName,
        //                        ItemTypeId: ItemTypeId,
        //                        CategoryId: CategoryId,
        //                        ProductTypeId: BaseItm,
        //                        SubCategoryId: SubCategoryId,
        //                        BrandId: BrandId,
        //                        SuperTypeId: SuperTypeId,
        //                        CollectionId: CollectionId,
        //                        UnitRate: Rate,
        //                        UnitLabour: LaborRate,
        //                        Pieces: 1,
        //                        Weight: Weight,
        //                        OtherPieces: value.OtherPieces,
        //                        OtherWeight: value.OtherWeight,
        //                        StonePieces: value.StonePieces,
        //                        StoneWeight: value.StoneWeight,
        //                        NetWeight: value.NetWeight,
        //                        TaxCode: value.TaxCode,
        //                        NetAmount: PrdDetails.HasBom ? (Rate + LaborRate) * 1 : (Rate * Weight) * purity,
        //                        GrossAmount: PrdDetails.HasBom ? (Rate + LaborRate) * 1 : (Rate * Weight) * purity,
        //                        DiamondPieces: value.DiamondPieces,
        //                        DiamondWeight: value.DiamondWeight,
        //                        CalcOnId: CalcOn,
        //                        //BOMDetails: bomdetails,
        //                        //LaborDetails: labordetail,
        //                        CompanyId: companyId,
        //                        HSN: value.HSN,
        //                        Purity: purity,
        //                        PureWeight: pureweight


        //                    };
        //                    orddetails.push(purchase);

        //                });

        //                if (this.view.getItems().length > 0) {
        //                    self.TotalItems = orddetails.length + this.view.getItems().length;
        //                }
        //                else {
        //                    self.TotalItems = orddetails.length;
        //                }
        //                for (let orderDetail of orddetails) {
        //                    orderDetail[this.getIdProperty()] = "`" + this.nextId++;
        //                    var x = orderDetail;
        //                    this.view.addItem(orderDetail);
        //                }

        //            }
        //            // #endregion

        //            pickerDialog.dialogOpen();
        //        }
        //    });


        //    //var btnAdd = Q.first(buttons, x => x.cssClass == "add-button");

        //    //btnAdd.onClick = e => { this.addButtonClick(); };

        //    return buttons;
        //}



        // #endregion




        /*
                validateEntity(row, id) {
                    row.P = Q.toId(row.ProductID);
        
                    var sameProduct = Q.tryFirst(this.view.getItems(), x => x.PrdId === row.ProductID);
                    if (sameProduct && this.id(sameProduct) !== id) {
                        Q.alert('This product is already in order details!');
                        return false;
                    }
        
                    return true;
                }*/
    }
}